import { render, staticRenderFns } from "./Marked.vue?vue&type=template&id=75704f70&scoped=true&"
import script from "./Marked.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Marked.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Marked.vue?vue&type=style&index=0&id=75704f70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75704f70",
  null
  
)

export default component.exports